/* 🤖 this file was generated by svg-to-ts */
export const matIconFormatColorText: {
  name: 'format-color-text';
  data: string;
} = {
  name: 'format-color-text',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2 20h20v4H2v-4zm3.49-3h2.42l1.27-3.58h5.65L16.09 17h2.42L13.25 3h-2.5L5.49 17zm4.42-5.61 2.03-5.79h.12l2.03 5.79H9.91z"/></svg>`
};
